
import axios from 'axios';

const instance = axios.create({ 
    baseURL: process.env.REACT_APP_URL_BASE_LISTA_ACUERDOS,
    headers: { "X-Api-Key" : process.env.REACT_APP_API_KEY_LISTA_ACUERDOS }
});

const request = {
    get: (url: string) => instance.get(url, { responseType: 'blob' } ),
    post: (url: string, body: any) => instance.post(url, body, { responseType: 'blob' } ),
}

export default request;